'use client';

import React from 'react';
import ActivitySuccessNonProfitBar from '../ActivitySuccessNonProfitBar';
import ProjectSuccessContent from './ProjectSuccessContent';

function ProjectSuccessDialog(props) {
  const { user, post, reward, type, isPost, isPostPublic, onClose } = props;

  const handleOnContinue = () => {
    onClose();
  };

  return (
    <div className="w-full">
      <ActivitySuccessNonProfitBar user={user} isPost={isPost} />

      <ProjectSuccessContent
        post={post}
        isPost={isPost}
        reward={reward}
        type={type}
        isPostPublic={isPostPublic}
        onContinue={handleOnContinue}
      />
    </div>
  );
}

export default ProjectSuccessDialog;
